// Single source of truth for module ids. Most are the cuids of the seeded
// global Module rows; the readable ids below them were hand-assigned rather
// than generated, and one of those names no Module row at all. Never inline
// these values at a call site — import them from here (directly, or via the
// re-exports in lib/on-the-fly.js and lib/rubrics/constants.js).
export const DISCOVERY_MODULE_ID = "clswpxzsl0001a4gpwdko3fys";
export const PITCH_MODULE_ID = "clswpxzsm0003a4gpe0q9z4ma";
export const OBJECTION_MODULE_ID = "clswpxzsl0000a4gpo97jqf1z";
export const COLD_CALL_MODULE_ID = "clzvi5r3y0000o61swmun4rbw";
export const PLAY_MODULE_ID = "cm1ub45r80000vhsa89dnikud";
export const ON_THE_FLY_MODULE_ID = "cmg9u6a4200006ocwui4sh3qd";
export const STORIES_MODULE_ID = "cmavrcqxc00001yi1ks3mt3wm";
export const CONVERSATION_SIMULATION_MODULE_ID = "clvylk92z0000103hfhuyggos";
// Module.id of the seeded "Conversation Analysis" row — this is the one to
// match against a Module (an entry from fetchEnabledModulesForWorkspace, a
// Rubric.moduleId, a WorkspaceModule.module). It is NOT interchangeable with
// CONVERSATION_ANALYSIS_SETTINGS_MODULE_ID below.
export const CONVERSATION_ANALYSIS_MODULE_ID = "cmcwbsaxi00011ywoa8f4lw3r";

// Hand-assigned ids. These three are still Module.id — they read like slugs
// only because they predate the cuid seeds.
export const MANAGEMENT_MODULE_ID = "management-practice-module-id";
export const DEAL_CLINIC_MODULE_ID = "dem-cog-module-id";
export const SCRIPT_GENERATOR_MODULE_ID = "script-generator-module-id";

// The only genuinely synthetic id: a moduleId the workspace module settings
// carry for conversation analysis with no Module row behind it. Matching it
// against a Module never hits — CONVERSATION_ANALYSIS_MODULE_ID above is the
// id for that.
export const CONVERSATION_ANALYSIS_SETTINGS_MODULE_ID =
  "conversation-analysis-module-id";
